import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { updateToken } from 'keycloak'

const baseQueryWithAuth = async (args: any, api: any, extraOptions: any) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: '',
    prepareHeaders: async (headers) => {
      const token = await updateToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  })

  return baseQuery(args, api, extraOptions)
}

export const baseApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ['DebugDocument', 'DebugRequete'],
  endpoints: () => ({}),
  keepUnusedDataFor: 5,
})
